import type { LogCategory, LogCategoryItem } from '@lmc/ts-common'
import _ from 'lodash'

const CHART_ICON_SOURCE_MAP = {
  body_maps: { type: 'category', keys: ['bodyMaps'] },
  fluids: { type: 'category', keys: ['foodDrink'] },
  meal: { type: 'category', keys: ['foodDrink'] },
  health_visit: { type: 'category', keys: ['healthVisit'] },
  incident: { type: 'category', keys: ['incident'] },
  activity_social: { type: 'category', keys: ['activitiesSocial'] },
  painchek: {
    type: 'item',
    keys: ['painchekPostMovement', 'painchekAtRest']
  },
  behaviour: { type: 'item', keys: ['behaviour'] },
  blood_pressure: {
    type: 'item',
    keys: ['blood_pressure_upper', 'blood_pressure_lower']
  },
  blood_glucose: {
    type: 'item',
    keys: ['blood_glucose_before', 'blood_glucose_after']
  },
  respiratory_rate: { type: 'item', keys: ['respiratory_rate'] },
  blood_oxygen: { type: 'item', keys: ['blood_oxygen'] },
  heart_rate: { type: 'item', keys: ['heart_rate'] },
  must: { type: 'item', keys: ['must'] },
  temperature: { type: 'item', keys: ['temperature'] },
  turns: { type: 'item', keys: ['turns'] },
  wash: { type: 'item', keys: ['wash'] },
  waterlow: { type: 'item', keys: ['waterlow'] },
  weight: { type: 'item', keys: ['weight'] },
  stool: { type: 'item', keys: ['stool'] },
  mood: { type: 'item', keys: ['mood'] },
  mobility: { type: 'item', keys: ['mobility'] },
  seizure: { type: 'item', keys: ['seizure'] }
}

export function getChartIconMap(
  logCategories: LogCategory[],
  logCategoryItems: LogCategoryItem[]
) {
  return _.mapValues(CHART_ICON_SOURCE_MAP, (source) => {
    if (source.type === 'category') {
      const category = logCategories.find((c) => source.keys.includes(c.itemId))
      if (!category) {
        return null
      }
      return {
        icon: category.icon,
        color: category.color
      }
    }

    const item = logCategoryItems.find((item) =>
      source.keys.some(
        (key) => item.amountOneKey === key || item.amountTwoKey === key
      )
    )
    if (!item) {
      return null
    }
    const category = logCategories.find((c) => c.id === item.category)

    return {
      icon: item.icon,
      color: category?.color
    }
  })
}
